import PropTypes from "prop-types";
import { forwardRef } from "react";

import { StyledLabel } from "./styles";

// ----------------------------------------------------------------------

const Label = forwardRef(
    (
        {
            children,
            color = "default",
            variant = "soft",
            startIcon,
            endIcon,
            sx = {},
            ...other
        },
        ref
    ) => {
        const computedSx = {
            ...(startIcon && { paddingLeft: 6 }),
            ...(endIcon && { paddingRight: 6 }),
            ...sx,
        };

        return (
            <StyledLabel
                ref={ref}
                component="span"
                ownerState={{ color, variant }}
                sx={computedSx}
                {...other}
            >
                {startIcon && (
                    <div className="hod-label__icon" style={{ marginRight: 6 }}>
                        {startIcon}
                    </div>
                )}

                {children}

                {endIcon && (
                    <div className="hod-label__icon" style={{ marginLeft: 6 }}>
                        {endIcon}
                    </div>
                )}
            </StyledLabel>
        );
    }
);

Label.propTypes = {
    sx: PropTypes.object,
    endIcon: PropTypes.node,
    children: PropTypes.node,
    startIcon: PropTypes.node,
    variant: PropTypes.oneOf(["filled", "outlined", "ghost", "soft"]),
    color: PropTypes.oneOf([
        "default",
        "primary",
        "secondary",
        "info",
        "success",
        "warning",
        "error",
    ]),
};

export default Label;
